import { GET, POST } from "./api.js";

export const company = {
    saveCompany: (data) => POST(`/company/create`, data),
}